import DefaultLoadingComponent from '../../components/global/LoadingComponent';
import DefaultErrorComponent from '../ErrorComponent/ErrorComponent';
import React from 'react';

import PropTypes from 'prop-types';

/**
 * Component for displaying async components. Pass in importFunc, that resolves with a React component. Set load to true
 * to load the component.
 */
export default class ComponentLoader extends React.Component {
    constructor() {
        super();

        this.state = {
            Component: null,
            isError: false,
            isLoading: false,
        };

        this.onLoadSuccess = this.onLoadSuccess.bind(this);
        this.onLoadFailure = this.onLoadFailure.bind(this);
    }

    componentDidMount() {
        if (this.props.load) {
            this.loadComponent();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.load && !this.state.Component) {
            this.loadComponent();
        }
    }

    loadComponent() {
        this.props
            .importFunc()
            .then(this.onLoadSuccess)
            .catch(this.onLoadFailure);
        this.setState({
            isLoading: true,
            isError: false,
        });
    }

    onLoadSuccess(moduleExport) {
        this.setState({
            Component: moduleExport,
            isLoading: false,
            isError: false,
        });
    }

    onLoadFailure(e) {
        console.error(e);
        this.setState({
            isLoading: false,
            isError: true,
        });
    }

    render() {
        const { Component, isLoading, isError } = this.state;
        /**
         * We don't want to pass unused props down, so we destruct this.props and just pass otherProps.
         */
        const {
            // eslint-disable-next-line no-unused-vars
            importFunc,
            // eslint-disable-next-line no-unused-vars
            load,
            LoadingComponent,
            ErrorComponent,
            useLoadingComponent,
            ...otherProps
        } = this.props;
        if (Component) {
            return <Component {...otherProps} />;
        } else if (isLoading && !!useLoadingComponent) {
            return <LoadingComponent />;
        } else if (isError) {
            return <ErrorComponent />;
        } else {
            return null;
        }
    }
}

ComponentLoader.defaultProps = {
    LoadingComponent: DefaultLoadingComponent,
    ErrorComponent: DefaultErrorComponent,
    useLoadingComponent: true,
};

ComponentLoader.propTypes = {
    importFunc: PropTypes.func.isRequired,
    load: PropTypes.bool,
    ErrorComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.element, PropTypes.func]),
    LoadingComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.element, PropTypes.func]),
    useLoadingComponent: PropTypes.bool.isRequired,
};
